import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { fetchTeamAccountBudgets, fetchTeamAccountBudgetConfigurationOptions, } from './budgets_slice';
import { BudgetsActions } from '../../constants/actions';
import { INITIAL_FETCH_STATUS } from '../../constants/fetch_status';
import { useSelector, useDispatch } from 'react-redux';
var FETCH_TEAM_ACCOUNT_BUDGETS = BudgetsActions.FETCH_TEAM_ACCOUNT_BUDGETS;
import { getTeamAccountBudgets, getStatusForAction, } from '../../selectors/budgets_selector';
import AdminBudgets from './admin_budgets';
export var AdminBudgetsContainer = function (props) {
    var teamAccountBudgets = useSelector(getTeamAccountBudgets);
    var statusForAction = useSelector(getStatusForAction);
    var fetchStatus = (statusForAction[FETCH_TEAM_ACCOUNT_BUDGETS] &&
        statusForAction[FETCH_TEAM_ACCOUNT_BUDGETS].status) ||
        INITIAL_FETCH_STATUS;
    var dispatch = useDispatch();
    var fetchContent = React.useCallback(function () {
        dispatch(fetchTeamAccountBudgets({
            teamAccountId: props.match.params.teamAccountId,
            includeGroupsInfo: true,
        }));
        dispatch(fetchTeamAccountBudgetConfigurationOptions({
            teamAccountId: props.match.params.teamAccountId,
        }));
    }, [props.match.params.teamAccountId, dispatch]);
    React.useEffect(function () {
        fetchContent();
    }, [props.match.params.teamAccountId, fetchContent]);
    return (React.createElement(AdminBudgets, { teamAccountId: props.match.params.teamAccountId, budgets: teamAccountBudgets, fetchStatus: fetchStatus }));
};
export default withRouter(AdminBudgetsContainer);
